import { CSSProperties } from 'react';
import theme from '../../theme';

export const styles = (): Record<string, CSSProperties> => ({
  divider: {
    borderColor: theme.colors.stroke[200]
  }
});
